export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
    visible: !that.disabled,
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    width: 85,
    align: 'center',
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    field: 'expand',
    type: 'expand',
    width: 70,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: { content: 'expandContent' },
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsNo') || '产品编号',
    field: 'orderGoodsNo',
    width: 150,
    align: 'center',
    sortable: true,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_label_identifyGoodsNo') || '产品识别编号',
    field: 'identifyGoodsNo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsName') || '产品名称',
    field: 'orderGoodsDisplayName',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
  },
  {
    title: that.$l('INDEX.master_category_categoryName') || '分类名称',
    field: 'masterCategoryName',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_label_isGroup') || '是否套装',
    field: 'v_isGroup',
    minWidth: 80,
    align: 'center',
    slots: { default: 'isGroup' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_isUseGroupHsCode') || '报关方式',
    field: 'v_isUseGroupHsCode',
    minWidth: 120,
    align: 'center',
    slots: { default: 'isUseGroupHsCode' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_customs_code_hscode') || '报关HSCODE',
    field: 'hscode',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
  },
  {
    title: that.$l('INDEX.shipment_customs_code_hscodeName') || '报关名称',
    field: 'hscodeName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_customs_code_hscodeNameEn') || '报关英文名称',
    field: 'hscodeNameEn',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_goodsSpecDisplay') || '规格尺寸',
    field: 'goodsSpecDisplay',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_orderBrandName') || '品牌',
    field: 'orderBrandName',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.master_category_categoryNameEn') || '分类英文名称',
    field: 'masterCategoryNameEn',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_orderGoodsFabricQuality') || '材质中文',
    field: 'orderGoodsFabricQuality',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_orderGoodsFabricQualityEn') || '材质英文',
    field: 'orderGoodsFabricQualityEn',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_orderGoodsFaceFabricContentEn') || '表面面料(英文)',
    field: 'orderGoodsFaceFabricContentEn',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsNameEn') || '英文描述',
    field: 'orderGoodsNameEn',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
  },
  {
    title: that.$l('INDEX.shipment_batch_box_goods_total_qty') || '发货数量',
    field: 'totalInPackageQty',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_orderGoodsTechnologyDesc') || '工艺备注',
    field: 'orderGoodsTechnologyDesc',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_batch_box_goods_inPackagePrice') || '工厂金额',
    field: 'v_totalInPackagePrice',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_batch_box_goods_inPackageSalePrice') || '客人金额',
    field: 'v_totalInPackageSalePrice',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_batch_box_goods_inPackageNetWeight') || '产品净重',
    field: 'totalInPackageNetWeight',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_batch_box_goods_goodsPrice') || '工厂单价',
    field: 'v_goodsPrice',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.shipment_batch_box_goods_goodsSalePrice') || '客人单价',
    field: 'v_goodsSalePrice',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
